import type { HandbookChapter } from './model';
import { arbeitChapters } from './chapters/arbeit';
import { betriebChapters } from './chapters/betrieb';
import { grundlagenChapters } from './chapters/grundlagen';
import { hilfeChapters } from './chapters/hilfe';
import { kundeChapters } from './chapters/kunde-und-datenschutz';
import { ticketChapters } from './chapters/tickets';
import { verwaltungChapters } from './chapters/verwaltung';

/**
 * Das Verzeichnis der Kapitel.
 *
 * **Die Reihenfolge ist die Leseordnung.** Sie geht vom Alltag zur
 * Einrichtung: erst was jeder tut, dann was ein Administrator einrichtet,
 * zuletzt das Nachschlagekapitel. Wer das Handbuch von vorn liest, kommt
 * nicht in die Verlegenheit, eine Servicezusage zu bauen, bevor er weiss,
 * was ein Ticket ist.
 *
 * **Zur Sprache.** ``de`` ist vollstaendig, ``en`` ist vorbereitet und noch
 * leer -- genau die Lage, die CLAUDE.md fuer die Oberflaeche beschreibt
 * ("``de`` als Standard, ``en`` vorbereitet"). Solange ein Sprachsatz leer
 * ist, faellt ``chaptersFor`` auf ``de`` zurueck. Ein Handbuch, das in
 * englischer Oberflaeche leer bliebe, waere schlechter als eines, das
 * deutsch bleibt.
 */

const de: HandbookChapter[] = [
  ...grundlagenChapters,
  ...ticketChapters,
  ...arbeitChapters,
  ...verwaltungChapters,
  ...betriebChapters,
  ...kundeChapters,
  ...hilfeChapters,
];

/** Noch nicht uebersetzt. Siehe Modulkopf. */
const en: HandbookChapter[] = [];

const BY_LANGUAGE: Record<string, HandbookChapter[]> = { de, en };

/** Die Kapitel in der gewuenschten Sprache, mit Rueckfall auf Deutsch. */
export function chaptersFor(language: string): HandbookChapter[] {
  const exact = BY_LANGUAGE[language];
  if (exact && exact.length > 0) return exact;

  // ``de-AT`` und ``en-GB`` sollen nicht ins Leere laufen.
  const base = BY_LANGUAGE[language.split('-')[0] ?? ''];
  if (base && base.length > 0) return base;

  return de;
}

/** Alle Kapitel der Standardsprache -- fuer Tests und Abgleiche. */
export const HANDBOOK_CHAPTERS = de;
